import React, { useState } from "react";
import Div from "@jumbo/shared/Div";
import ButtonStyled from "app/components/ButtonStyled/ButtonStyled";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Typography } from "@mui/material";
import InputForm from "app/components/InputForm/InputForm";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { REFERRER } from "app/utils/constants/endPoint";
import { requestApi } from "app/utils/RestApi";
import ContentWrapper from "app/components/ContentWrapper/ContentWrapper";
import Link from "@mui/material/Link";
import { connect } from "react-redux";
import schemaEmail from "./schema";
import { Field, Formik } from "formik";

const MicrositeLupaPassword = (props) => {
  const navigate = useNavigate();
  const [isEditable, setIsEditable] = useState(true);
  const [fieldTouched, setFieldTouched] = React.useState(false);

  const sendData = async (data) => {
    await Swal.fire({
      title: "Mohon Tunggu..",
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        requestApi(REFERRER.FORGOT_PWD, {
          data: {
            email: data.email.toLowerCase().replace(/ /g, ""),
          },
        })
          .then(({ data }) => {
            if (data.status == "success") {
              Swal.fire({
                icon: "success",
                text: "Jika akun terdaftar, kata sandi baru akan dikirim melalui email anda.",
                allowOutsideClick: true,
              });
              navigate("/micrositeLogin");
            }
          })
          .catch((err) => {
            console.log(err);
            if (err?.message) {
              setTimeout(() => {
                Swal.fire({
                  icon: "warning",
                  text: err.message,
                  allowOutsideClick: false,
                  confirmButtonColor: "red",
                });
              }, 1000);
            } else {
              setTimeout(() => {
                Swal.fire({
                  icon: "warning",
                  text: !err?.detail ? err?.title : err?.detail,
                  allowOutsideClick: false,
                  confirmButtonColor: "red",
                });
              }, 1000);
            }
          });
      },
      showCloseButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
    });
  };

  React.useEffect(() => {
    document.querySelector("html").classList.add("overflow-hidden");
  }, []);

  const backHandler = () => {
    navigate(-1);
  };

  return (
    <Div className="page-wrapper login">
      <Div>
        <Div sx={{ position: "relative", zIndex: 1, mb: "60px" }}>
          <Link href="#" underline="none" sx={{ display: "inline-flex" }}>
            <Div className="bg-custom-logo">
              <img
                src={`${process.env.REACT_APP_IMAGES_PATH}/logo-generali.png`}
                width={150}
                height={122}
              />
            </Div>
          </Link>
        </Div>
      </Div>
      <Div className="custompage">
        <ContentWrapper>
          <Div className="content-padding">
            <Formik
              initialValues={{
                email: "",
              }}
              validateOnMount
              enableReinitialize={true}
              validationSchema={schemaEmail}
              onSubmit={(values) => {
                sendData(values);
              }}
            >
              {({ errors, handleSubmit }) => {
                return (
                  <>
                    <Div>
                      <Div className="back-icon">
                        <KeyboardBackspaceIcon onClick={backHandler} />
                      </Div>
                      <Div className="flex-justify-center-title ">
                        <Typography
                          fontSize={24}
                          fontWeight={600}
                          color={"#C21B17"}
                        >
                          Lupa Kata Sandi
                        </Typography>
                      </Div>
                    </Div>
                    <Div className="mt-2">
                      <Div className="p-4">
                        <Typography fontSize={20} fontWeight={600}>
                          Silakan Masukkan Email Terdaftar Anda
                        </Typography>
                        <Field name="email">
                          {({ form: { handleChange }, meta }) => (
                            <>
                              <InputForm
                                required
                                sx={{ mt: 4 }}
                                inputLabel={"Email Terdaftar"}
                                placeholder={"Email Terdaftar"}
                                size={"small"}
                                name="email"
                                value={meta.value}
                                readOnly={!isEditable}
                                onChange={handleChange}
                                onBlur={() => {
                                  if (!fieldTouched) {
                                    setFieldTouched(true);
                                  }
                                }}
                              />
                              {fieldTouched && meta.error && (
                                <span
                                  style={{ color: "red", marginTop: "-10px" }}
                                >
                                  {errors.email}
                                </span>
                              )}
                            </>
                          )}
                        </Field>
                      </Div>
                    </Div>
                    <Div className="flex-justify-center" sx={{ mt: 2 }}>
                      <ButtonStyled
                        onClick={handleSubmit}
                        btnText={"Kirim"}
                        preset={"primary"}
                        sx={{ maxWidth: "451px" }}
                        disabled={Object.values(errors).length > 0}
                      />
                    </Div>
                  </>
                );
              }}
            </Formik>
          </Div>
        </ContentWrapper>
      </Div>
    </Div>
  );
};
const mapStateToProps = (state) => ({
  authMicrosite: state.authMicrosite,
});

export default connect(mapStateToProps)(MicrositeLupaPassword);
